import i18next from 'i18next';
import AssessmentsLogo from '../../../../../components/Shared/Icons/AssessmentsLogo';
import ReportView from '../../../../../components/Reports/ReportView';
import Assessments from '../../../../../components/Assessments/List';

const ASSESSMENT_ROUTE_LIST_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/assessments',
  exact: true,
  additional: {
    component: Assessments,
    protected: true,
    title: i18next.t('titles:assessments'),
    icon: AssessmentsLogo,
  },
};

const ASSESSMENT_ROUTE_REPORT_DS = {
  path:
    '/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/assessments/:assessmentUuid/:status/report',
  exact: true,
  parentRoute: ASSESSMENT_ROUTE_LIST_DS,
  additional: {
    component: ReportView,
    protected: true,
    title: i18next.t('titles:reports'),
  },
};

const ASSESSMENT_ROUTE_LIST = {
  path: '/:currentAccountUuid/assessments',
  exact: true,
  additional: {
    component: Assessments,
    protected: true,
    title: i18next.t('titles:assessments'),
    icon: AssessmentsLogo,
  },
};

const ASSESSMENT_ROUTE_REPORT = {
  path:
    '/:currentAccountUuid/patients/:patientUuid/assessments/:assessmentUuid/:status/report',
  exact: true,
  parentRoute: ASSESSMENT_ROUTE_LIST,
  additional: {
    component: ReportView,
    protected: true,
    title: i18next.t('titles:reports'),
  },
};

export const ASSESSMENT_ROUTES = {
  // ------- For child accounts ------
  listDS: ASSESSMENT_ROUTE_LIST_DS,
  reportDS: ASSESSMENT_ROUTE_REPORT_DS,

  // ------- For current accounts ------
  list: ASSESSMENT_ROUTE_LIST,
  report: ASSESSMENT_ROUTE_REPORT,
};
